import { useState } from 'react';

export const usePopover = () => {
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | undefined>();

  const open = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const close = () => {
    setAnchorElement(undefined);
  };

  const isOpen = Boolean(anchorElement);

  return { open, close, isOpen, anchorElement };
};
